document.addEventListener("DOMContentLoaded", function () {
    const descriptionText = document.getElementById("description-text");
    const fullDescription = document.getElementById("full-description");
    const toggleButton = document.getElementById("toggle-description");

    toggleButton.addEventListener("click", function () {
        if (descriptionText.style.display !== "none") {
            // Kısa metni gizle, tam metni göster
            descriptionText.style.display = "none";
            fullDescription.style.display = "block";
            toggleButton.textContent = "Daha Az Göster";
        } else {
            // Tam metni gizle, kısa metni göster
            fullDescription.style.display = "none";
            descriptionText.style.display = "block";
            toggleButton.textContent = "Daha Fazla Göster";
        }
    });
});
